export function urlSafe(value) {
    if (value)
        return value.replace(/[,./\\ ()?=\[\]*$%^&#@!±§`~]/g, '-')
            .replace(/---/g, '-')
            .replace(/--/g, '-')
            .toLowerCase();
    return '';
}
var urlPrefix = 'url_';
/**
 * Creates a new url safe property based on the specified propert key.
 * New property will be prefixed by: url_
 * @param propertyKey The property key to make url safe.
 * @param alternateName Will be used as a new name for the property, will not be prefixed.
 */
export function makeUrlSafe(propertyKey, alternateName) {
    return function (target) {
        target.forEach(function (value) {
            var _a;
            Object.assign(value, (_a = {},
                _a[alternateName || (urlPrefix + propertyKey)] = urlSafe(value[propertyKey]),
                _a));
        });
        return target;
    };
}
/**
 * Creates a url safe version of the requested search term.
 * @param term The search term to make url safe
 */
export function makeSearchTermUrl(term) {
    return encodeURIComponent(term);
}
/**
 * Creates a humanized search term from the urlified version.
 * @param urlTerm The search term from the url
 */
export function getFromUrlTerm(urlTerm) {
    if (!urlTerm)
        return urlTerm;
    return decodeURIComponent(urlTerm);
}
